$(document).ready(function () {
  "use strict";

  //-----Header Sticky-----
  window.onscroll = function () {
    myFunction();
  };
  var header = document.querySelector(".header");
  var banner = document.querySelector(".banner");
  var wrapperBlock = document.querySelector(".wrapper");
  var sticky = header.offsetTop + 89;
  function myFunction() {
    if (window.pageYOffset >= sticky) {
      if (banner) {}
      if (wrapperBlock) {
        wrapperBlock.classList.add("wrapperSticky");
      }
    } else {
      if (banner) {}
      if (wrapperBlock) {
        wrapperBlock.classList.remove("wrapperSticky");
      }
    }
  }
  //-----Header Sticky-----
  var ww = $(window).width();
  if ($('.menu > ul > li:has( > ul)')) {
    $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
    $('.menu > ul > li > ul').addClass('sub-menu-dropdown');
    if (ww <= 1040) {
      $('.menu > ul > li:has( > ul)').append($("<span class='menu-dropdown-img'><img src='/wp-content/themes/more4app-1941/assets/img/arrow-down.svg'></span>"));
    } else {
      $('.menu > ul > li:has( > ul) > a').append($("<span class='menu-dropdown-img'><img src='/wp-content/themes/more4app-1941/assets/img/arrow-down.svg'></span>"));
    }
  }
  // --- ARROW ---
  $('.menu > ul > li').hover(function () {
    $(this).find('.menu-dropdown-img').toggleClass('menu-dropdown-img-hover');
    $(this).click(function () {});
  });
  // --- !ARROW ---
  var ww = $(window).width();
  function ss() {
    var hhe = $('header').outerHeight();
    var fhe = $('footer').outerHeight();
    var mhe = hhe + fhe;
    $('body').css('padding-top', hhe + 'px');
    $('.wrapper').css('min-height', 'calc(100% - ' + mhe + 'px)');
  }
  setTimeout(ss, 300);
  $(window).on('load resize', function () {
    setTimeout(ss, 300);
  });
  function closemenu() {
    $('.menu').find('.showc').slideUp();
    $('.menu').find('.showc').removeClass('showc');
    $('.menu').removeClass('showlic');
    $('.menu img').removeClass('imgtop');
  }
  $('.menu > ul > li.menu-dropdown-icon > .menu-dropdown-img').on('click', function (e) {
    if (ww <= 1040) {
      if (e.target.nodeName == 'IMG') {
        e.preventDefault();
        var ul = $(this).parent().find('ul');
        if ($(ul).hasClass('showc')) {
          closemenu();
        } else {
          closemenu();
          $(this).parent().find('img').addClass('imgtop');
          $(this).parent().find('> ul').addClass('showc');
          $(this).parent().addClass('showlic');
          $(this).parent().find('> ul').slideDown(500);
        }
      }
    } else {
      if (e.target.nodeName == 'IMG') {
        e.preventDefault();
      }
    }
  });
  $('.menu-dropdown-img').click(function () {});
  jQuery(function ($) {
    $(document).mouseup(function (e) {
      var block2 = $(".menu > ul > li > ul");
      var block = $(".menu");
      if (!block.is(e.target) && block.has(e.target).length === 0) {
        closemenu();
      }
    });
  });
  $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
  $('.menu > ul > li > ul:not(:has(ul))').addClass('normal-sub');
  $(".menu > ul > li.simple > ul").addClass("normal-sub"), $(".menu > ul").before("<a href=\"/\" class=\"menu-mobile\"><img src='/wp-content/themes/more4app-1941/assets/img/logo.svg'><div class=\"menu-mobile-toggle\"></div></a>");
  $(".menu > ul > li").click(function (e) {
    if ($(window).width() <= 1040) {}
  });
  $(".menu-mobile-toggle").click(function (e) {
    e.preventDefault();
    $('body').toggleClass('opmenu');
    $(".menu > ul").toggleClass('show-on-mobile');
    $(".header__btn").toggleClass('show-on-mobile');
    // $(".search__mobile").toggleClass( 'search__mobile-hidden' );

    // $(this).parent().find('.Headermenu').slideToggle(300);
    // $(this).parent().find('.header__btn').slideToggle(300);
  });

  $('.menu > ul > li:has( > ul > li > ul )').hover(function () {
    if (ww > 1040) {
      var ouh = $(this).find('.sub-menu-dropdown').outerHeight();
      var thid = $(this).attr('id');
      $(this).find('.sub-menu-dropdown').attr('data-he', ouh);
      $('header #style').remove();
      $('header').append('<style id="style">#' + thid + ' .sub-menu.sub-menu-dropdown:before {height:' + ouh + 'px}</style>');
    }
  });
  $("button.search").click(function () {
    if ($('#serchresDesc').val() == '') {
      $('.search__input-card').toggleClass('searchbar-on');
    }
  });

  // Toogle accordion on product index

  $('.product-index__item-toggle').click(function () {
    $(this).find('span').toggleClass('minus');
    $(this).parent().parent().find('.product-index__item-body').slideToggle();
  });
});